import moment from 'moment'

export const DATE_FORMAT = 'DD.MM.YYYY'

export function validateFilters (filters) {
  const from = moment(filters.from, DATE_FORMAT, true)
  const to = moment(filters.to, DATE_FORMAT, true)

  if (!from.isValid() || !to.isValid()) {
    return 'Укажите существующие даты в формате ДД.ММ.ГГГГ.'
  }

  const days = to.diff(from, 'days') + 1

  if (days < 1) {
    return 'Дата начала не должна быть позже даты окончания.'
  }

  if (days > 366) {
    return 'Выберите период не длиннее 366 дней включительно.'
  }

  if (!['day', 'week', 'month'].includes(filters.groupBy)) {
    return 'Выберите группировку по дням, неделям или месяцам.'
  }

  if (!Number.isInteger(Number(filters.topLimit)) || Number(filters.topLimit) < 1 || Number(filters.topLimit) > 50) {
    return 'Количество топ-товаров должно быть от 1 до 50.'
  }

  return ''
}

export function requestFilters (filters) {
  const payload = {
    from: filters.from,
    to: filters.to,
    groupBy: filters.groupBy,
    topLimit: Number(filters.topLimit)
  }

  if (filters.userId !== '' && filters.userId != null) {
    payload.userId = String(filters.userId)
  }

  return payload
}

export function formatMetric (value, unit = 'number', signed = false) {
  if (value == null || !Number.isFinite(Number(value))) {
    return '—'
  }

  const number = Number(value)

  const options = { maximumFractionDigits: 2 }

  if (unit === 'money') {
    Object.assign(options, { style: 'currency', currency: 'RUB' })
  }

  const text = new Intl.NumberFormat('ru-RU', options).format(number)

  const suffix = unit === 'percent' ? ' %' : unit === 'points' ? ' п.п.' : ''

  return `${signed && number > 0 ? '+' : ''}${text}${suffix}`
}

export function hasChartData (data) {
  return Boolean(data?.labels?.length && data?.datasets?.some(dataset =>
    dataset.data?.some(value => Number.isFinite(value) && value !== 0)
  ))
}

export function chartConfig (chart, data) {
  const colors = ['#408df2', '#39a68a', '#a185d8']
  const color = chart.type === 'doughnut' ? { backgroundColor: colors } : {}
  const label = ({ dataset, label, parsed }) => `${dataset.label || label}: ${formatMetric(chart.type === 'doughnut' ? parsed : parsed.y, chart.unit)}`

  return {
    type: chart.type,
    data: {
      labels: [...data.labels],
      datasets: data.datasets.map(dataset => ({
        ...dataset,
        ...color,
        data: [...dataset.data],
      }))
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        mode: 'index',
        intersect: false
      },
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true,
            boxWidth: 10
          }
        },
        tooltip: {
          callbacks: { label }
        }
      },
      ...(chart.type === 'doughnut' ? {} : {
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              autoSkip: true,
              maxRotation: 45
            }
          },
          y: {
            beginAtZero: true,
            ticks: chart.unit === 'number' ? { precision: 0 } : {}
          }
        }
      })
    }
  }
}
